/* OCC 41–51: explicit variant selection and the native Shopify cart. */
(() => {
  'use strict';
  if (customElements.get('occ-purchase')) return;
  class Purchase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.giftDiscount = Number(this.dataset.giftDiscount) || 0;
      this.form = this.querySelector('form'); this.add = this.querySelector('[data-add]');
      this.message = this.querySelector('[data-message]'); this.quantity = this.form.elements.quantity;
      this.fields = [...this.querySelectorAll('fieldset')];
      this.form.addEventListener('change', e => { if (e.target.type === 'radio') this.update(true); });
      // Clicking an already chosen colour photo should return to that photo too.
      this.form.addEventListener('click', e => {
        const input=e.target.closest('.occ-purchase__choice')?.querySelector('input');
        if(e.target!==input && input?.checked && (input.closest('[data-colour-field]') || /^options\[colou?r\]$/i.test(input.name))) this.previewImage();
      });
      this.form.addEventListener('submit', e => this.submit(e));
      const requested = new URL(location.href).searchParams.get('variant');
      const variant = this.variants.find(v => String(v.id) === requested);
      if (variant) this.fields.forEach((field,i) => [...field.querySelectorAll('input')].forEach(input => input.checked = input.value === variant.options[i]));
      const colour = new URL(location.href).searchParams.get('occ_colour');
      if (!variant && colour) this.fields.forEach(field => field.querySelectorAll('input').forEach(input => {
        if ((field.hasAttribute('data-colour-field') || /options\[(colou?r)\]/i.test(input.name)) && input.value === colour) input.checked = true;
      }));
      this.update(false);
      if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',()=>setTimeout(()=>this.update(false),0),{once:true});
      const sticky = document.querySelector('[data-occ-sticky]');
      if (sticky) {
        sticky.querySelector('button').addEventListener('click', () => {
          if (!this.selected?.available) { this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'}); this.fields.find(f=>!f.querySelector(':checked'))?.querySelector('input')?.focus({preventScroll:true}); this.say('Choose your size and colour above.'); }
          else this.form.requestSubmit(this.add);
        });
        const visibility = () => {
          const overlay = [...document.querySelectorAll('cart-drawer.active,dialog[open],.size-chart-popup.active,[data-occ-wishlist-drawer].is-open,.react-responsive-modal-container')].some(node=>node.checkVisibility?node.checkVisibility({checkOpacity:true,checkVisibilityCSS:true}):node.getClientRects().length>0);
          // Native size/colour radios do not open an on-screen typing keyboard.
          const keyboard = document.activeElement?.matches('textarea,select,input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="range"]):not([type="color"]):not([type="file"]):not([type="hidden"])');
          sticky.hidden = this.add.getBoundingClientRect().bottom > 0 || !!overlay || keyboard;
        };
        this.sticky = sticky;
        addEventListener('scroll',visibility,{passive:true});
        document.addEventListener('focusin',visibility);document.addEventListener('focusout',()=>setTimeout(visibility,50));
        new MutationObserver(visibility).observe(document.body,{attributes:true,childList:true,subtree:true,attributeFilter:['class','open']});
        visibility(); this.syncSticky();
      }
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-ZA',{style:'currency',currency:this.dataset.currency}).format(cents/100); }
    say(text) { this.message.textContent=text; }
    update(change) {
      const values=this.fields.map(f=>f.querySelector(':checked')?.value);
      this.selected=this.fields.length ? this.variants.find(v=>values.every((s,i)=>s && s===v.options[i])) : this.variants[0];
      const v=this.selected; this.form.elements.id.value=v?.id || '';
      if(change && !this.reviewRequired)this.say('');
      this.fields.forEach((field,i)=>{
        field.querySelector('[data-chosen]').textContent=values[i] || 'Choose an option';
        field.querySelectorAll('input').forEach(input=>{
          const possible=this.variants.some(item=>item.available && item.options[i]===input.value && values.every((val,j)=>j===i || !val || item.options[j]===val));
          // Keep every choice reachable so a shopper can change a previous colour/size.
          input.closest('label').classList.toggle('is-unavailable',!possible);
          input.closest('label').querySelector('[data-unavailable]').hidden=possible;
        });
      });
      this.querySelector('[data-availability]').textContent=!v?'Choose all options to check availability.':v.available?'Available: '+v.title:'Unavailable: '+v.title+'. Choose another option.';
      this.add.disabled=!!this.busy || !!this.reviewRequired || (!!v && !v.available);
      this.add.textContent=this.busy?'Adding…':this.reviewRequired?'Review cart':v && !v.available?'Sold out':'Add to cart';
      const stock=this.querySelector('[data-stock]');
      stock.hidden=!(v?.available && v.tracked && v.stock>0 && v.stock<=5);
      stock.textContent=stock.hidden?'':'Only '+v.stock+' left in '+v.title+'. Stock is not reserved.';
      if(v) {
        this.quantity.min=v.min;this.quantity.step=v.step;
        let max=v.max;if(v.tracked)max=max ? Math.min(max,v.stock):v.stock;
        if(max>0)this.quantity.max=max;else this.quantity.removeAttribute('max');
        if(!this.quantity.value || Number(this.quantity.value)<v.min)this.quantity.value=v.min;
        this.querySelector('[data-rules]').textContent='Minimum '+v.min+'. Increments of '+v.step+'.'+(max>0?' Maximum currently available: '+max+'.':'')+' Stock is checked again when adding.';
        if(change) { const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(history.state,'',url); }
      } else {
        this.querySelector('[data-rules]').textContent='Choose your options to see quantity limits.';
      }
      this.updatePrice(values);
      this.previewImage(values);
      this.syncSticky();
    }
    displayPrice(variant) { return Math.round(variant.price * (1 - this.giftDiscount / 100)); }
    updatePrice(values) {
      const candidates = this.selected ? [this.selected] : this.variants.filter(item => values.every((value, index) => !value || item.options[index] === value));
      if (!candidates.length) return;
      const lowest = candidates.reduce((a, b) => a.price <= b.price ? a : b);
      const varied = candidates.some(item => item.price !== lowest.price);
      const price = this.displayPrice(lowest);
      const regular = this.giftDiscount ? lowest.price : lowest.compare;
      this.displayedPrice = price;
      this.querySelector('[data-price]').textContent = (varied ? this.dataset.fromLabel + ' ' : '') + this.money(price);
      const compare = this.querySelector('[data-compare]');
      const saving = this.querySelector('[data-saving]');
      compare.hidden = saving.hidden = !(regular > price);
      compare.textContent = regular > price ? this.money(regular) : '';
      saving.textContent = regular > price ? this.dataset.saleLabel + ' · ' + Math.round((regular - price) / regular * 100) + '%' : '';
    }
    previewImage(values=this.fields.map(f=>f.querySelector(':checked')?.value)) {
      const exact=this.fields.length ? this.variants.find(v=>values.every((value,i)=>value && value===v.options[i])) : this.variants[0];
      const colourIndex=this.fields.findIndex(f=>f.hasAttribute('data-colour-field') || /^options\[colou?r\]$/i.test(f.querySelector('input')?.name || ''));
      // A colour can preview its photo before a size is chosen, even if sold out.
      // Keep this separate from the exact variant used for stock, price and cart.
      const photo=exact?.media ? exact : colourIndex>=0 && values[colourIndex] ? this.variants.find(v=>v.options[colourIndex]===values[colourIndex] && v.media) : null;
      if(photo)document.dispatchEvent(new CustomEvent('variant:imageChanged',{detail:{variantId:photo.id,mediaId:photo.media,imageUrl:photo.image}}));
    }
    syncSticky() {
      if(!this.sticky)return;
      this.sticky.querySelector('[data-sticky-selection]').textContent=this.selected?this.selected.title+' · '+this.money(this.displayPrice(this.selected)):'Choose your size / colour';
      this.sticky.querySelector('button').textContent=this.busy?'Adding…':this.selected?.available?'Add to cart':'Choose options';
      this.sticky.querySelector('button').disabled=!!this.busy;
    }
    async submit(event) {
      event.preventDefault();event.stopPropagation();
      if(this.busy || this.reviewRequired)return;
      if(!this.selected?.available){this.say('Please choose an available size and colour before adding.');this.message.focus();return;}
      if(!this.quantity.checkValidity()){this.quantity.reportValidity();return;}
      if(window.occCartMutationBusy){this.say('Your cart is updating. Please wait and try again.');return;}
      this.busy=true;const owner={};window.occCartMutationBusy=owner;this.add.disabled=true;this.add.textContent='Adding…';this.setAttribute('aria-busy','true');this.syncSticky();this.say('Adding your selected option…');
      const drawer=document.querySelector('cart-drawer');
      const form=new FormData(this.form);form.set('sections','cart-drawer,cart-icon-bubble');form.set('sections_url',location.pathname);
      this.fields.forEach(field=>field.disabled=true);this.quantity.disabled=true;
      let sent=false;
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),12000);
      try {
        sent=true;
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:form,signal:controller.signal});
        const result=await response.json();
        if(!response.ok || result.status>=400) {
          this.say(result.description || 'The store could not add that quantity. Check your cart before trying again.');
          // Shopify can partially add stock on 422; require a fresh cart, never auto-retry.
          this.requireReview();return;
        }
        this.say('Added '+this.selected.title+' to your cart.');
        if(drawer && typeof drawer.renderContents==='function' && result.sections?.['cart-drawer']) {
          drawer.setActiveElement?.(this.add);drawer.renderContents(result);
        } else this.requireReview();
      } catch(error) { this.say(sent?'The add could not be confirmed. It may have reached the cart. Review your cart before trying again.':'The product could not be added.');this.requireReview(); }
      finally { clearTimeout(timer);this.fields.forEach(field=>field.disabled=false);this.quantity.disabled=false;if(window.occCartMutationBusy===owner)window.occCartMutationBusy=false;this.busy=false;this.setAttribute('aria-busy','false');this.add.disabled=!!this.reviewRequired;this.add.textContent=this.reviewRequired?'Review cart':'Add to cart';this.syncSticky(); }
    }
    requireReview(){this.reviewRequired=true;this.querySelector('[data-review]').hidden=false;}
  }
  customElements.define('occ-purchase',Purchase);
})();
